// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { changePasswordRequested } from '../../store/auth.actions';
import { ActivatedRoute, Router } from '@angular/router';
import { ChangePasswordPayload } from '@coa/app/libs/auth/auth-module/models/change-password-payload';


@Component({
  selector: 'coa-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss'],
})
export class ChangePasswordComponent implements OnInit {

  constructor(
    private store$: Store,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    if (!this.activatedRoute.snapshot.queryParams.username) {
      this.router.navigate(['login']);
    }
  }

  change(changePasswordPayload: ChangePasswordPayload): void {
    const body = {
      username: this.activatedRoute.snapshot.queryParams.username,
      ...changePasswordPayload,
    };
    this.store$.dispatch(changePasswordRequested(body));
  }
}
